// extracted by mini-css-extract-plugin
export default {"card":"StatCard_card__wzU49","value":"StatCard_value__JJPyi","label":"StatCard_label__TkRgu"};